import styled from 'styled-components'

import { LiveBadgeProps } from './liveBadge.types'

export const LiveIconBox = styled.div<Omit<LiveBadgeProps, 'className'>>`
  max-width: 54px;
  color: ${({ invert = false }) => (invert ? 'var(--white)' : 'var(--red)')};
  background-color: ${({ invert = false }) => (invert ? 'var(--red)' : 'var(--white)')};
  font-size: 0.625rem;
  line-height: 1rem;
  padding-top: 2px;
  padding-bottom: 2px;

  & svg {
    width: 1rem;
    height: 1rem;
  }
`

LiveIconBox.displayName = 'LiveIconBox'
